import { render, staticRenderFns } from "./AffinityAssociationTooltip.vue?vue&type=template&id=99c47a62&scoped=true"
import script from "./AffinityAssociationTooltip.vue?vue&type=script&lang=js"
export * from "./AffinityAssociationTooltip.vue?vue&type=script&lang=js"
import style0 from "./AffinityAssociationTooltip.vue?vue&type=style&index=0&id=99c47a62&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99c47a62",
  null
  
)

export default component.exports